export function sendGaFromConfig(cfgJson) {
    try {
        let cfgs = JSON.parse(cfgJson);
        cfgs = Array.isArray(cfgs) ? cfgs : [cfgs];
        cfgs.forEach((cfg) => {
            Hop.safeGA('send', 'event', cfg.category, cfg.action, cfg.label, cfg.value);
        });
    } catch (e) {
        Hop.logError(e);
    }
}
